import { forwardRef } from "react";
import { Tag, TagLabel, TagCloseButton, TagProps } from "@chakra-ui/react";

export interface TaskActionPillProps extends TagProps {
  label: string;
  onRemove?: () => void;
}

// Tag is rendered as a div, so ref is HTMLDivElement
const TaskActionPill = forwardRef<HTMLDivElement, TaskActionPillProps>(
  ({ label, onRemove, ...rest }, ref) => (
    <Tag ref={ref} size="md" colorScheme="gray" borderRadius="full" cursor="pointer" {...rest}>
      <TagLabel ml="1" mr=".5">
        {label}
      </TagLabel>
      {onRemove && <TagCloseButton onClick={onRemove} />}
    </Tag>
  ),
);

TaskActionPill.displayName = "TaskActionPill";

export default TaskActionPill;
